import './simpleShareableLinkModal.scss';
import '@justgiving/modal/src/Modal.scss';

import React, { FunctionComponent, useState } from 'react';

import AddDonateButton from '../AddDonateButton/AddDonateButton';
import { FormContext } from '../FormContext/FormContext';
import GivingCheckoutLink from '../GivingCheckoutLink/GivingCheckoutLink';
import { Link } from 'react-router-dom';
import Modal from '@justgiving/modal';
import { PAGES } from '../../constants/pages';
import QRCode from '../QRCode/QRCode';
import classNames from 'classnames';
import config from '../../config';
import { useCharityData } from '../../context/charityContext';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  url?: string;
  linkId?: string;
  hideFooter?: boolean;
  isDefault: boolean;
};
type SharableLinkType = 'link' | 'button' | 'qrcode';

const SimpleSharableLinkModal: FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();
  const [shareableLinkType, setShareableLinkType] =
    useState<SharableLinkType>('link');

  const { charityId } = useCharityData();
  const link = props?.url ?? `${config.SIMPLE_SHORT_URL}${charityId}`;

  const renderType = () => {
    switch (shareableLinkType) {
      default:
      case 'link':
        return <GivingCheckoutLink link={link} id="multi" type="single" />;
      case 'button':
        return (
          <AddDonateButton
            linkId={props.linkId}
            codeBlockType="single"
            isDefault={props.isDefault}
          />
        );
      case 'qrcode':
        return <QRCode link={link} centreImage={true} />;
    }
  };

  return (
    <Modal
      {...props}
      className="simpleShareableLinkModal"
      style={{
        overlay: { zIndex: 100 },
        content: {
          padding: 0,
          margin: 'auto',
          right: 'unset',
        },
      }}
    >
      <FormContext>
        <div className="jg-text--center">
          <h2>{t('simpleShareableLink.title')}</h2>
          <p className="jg-color--empress jg-font-weight-regular">
            {t('simpleShareableLink.subTitle')}
          </p>
        </div>
        <nav className="simpleShareableLinkModal__nav">
          <ul>
            <li>
              <button
                className={classNames('simpleShareableLinkModal__nav__button', {
                  isActive: shareableLinkType === 'link',
                })}
                type="button"
                onClick={() => setShareableLinkType('link')}
              >
                {t('simpleShareableLink.nav.link')}
              </button>
            </li>
            <li>
              <button
                className={classNames('simpleShareableLinkModal__nav__button', {
                  isActive: shareableLinkType === 'button',
                })}
                type="button"
                onClick={() => setShareableLinkType('button')}
              >
                {t('simpleShareableLink.nav.button')}
              </button>
            </li>
            <li>
              <button
                className={classNames('simpleShareableLinkModal__nav__button', {
                  isActive: shareableLinkType === 'qrcode',
                })}
                type="button"
                onClick={() => setShareableLinkType('qrcode')}
              >
                {t('simpleShareableLink.nav.qrcode')}
              </button>
            </li>
          </ul>
        </nav>
        {renderType()}
        {!props.hideFooter && (
          <div className="simpleShareableLinkModal__footer">
            {t('simpleShareableLink.footer.intro')}
            <br />
            <Link to={PAGES.Frequency} data-track="setup-checkout-continue">
              {t('simpleShareableLink.footer.link')}
            </Link>
          </div>
        )}
      </FormContext>
    </Modal>
  );
};

export default SimpleSharableLinkModal;
